import React, { Component } from "react";
import { Row, Col, Card, CardBody, FormGroup, Button, Label, Container, Spinner, Modal, ModalHeader, ModalBody } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { validateToken } from '../../helpers/jwt-token-access/accessToken';
import Select from "react-select";
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { BaseUrl } from "../../helpers/Baseurl";
import { Link } from "react-router-dom";
import axios from "axios";

class AddHotelPricing extends Component {
  constructor(props) {
    super(props);
    this.obj = JSON.parse(localStorage.getItem("authUser"));
    if (!this.obj || !validateToken(this.obj.access)) {
      this.props.history.push('/logout');
    }

    this.state = {
      loading: false,
      roomsloding: false,
      facilityloading: false,
      breadcrumbItems: [
        { title: "Hotels", link: "/hotels" },
        { title: "Add Hotel Pricing", link: "#" },
      ],
      selectedRoom: { label: "Select Room", value: null },
      selectedFacilities: [],
      FacilityGroup: [],
      RoomGroup: "",
      count: 1,
      model_rooms: false,
      model_facility: false,
    };

    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: true,
      progressBar: true,
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleRoomSubmit = this.handleRoomSubmit.bind(this);
    this.handleFacilitySubmit = this.handleFacilitySubmit.bind(this);
    this.handleselectedFacilityGroup = this.handleselectedFacilityGroup.bind(this);
    this.handleselectedRoomGroup = this.handleselectedRoomGroup.bind(this);
    this.tog_center = this.tog_center.bind(this);
    this.tog_facility = this.tog_facility.bind(this);
    this.removeInput = this.removeInput.bind(this);
    this.addInput = this.addInput.bind(this);
  }

  tog_center() {
    this.setState(prevState => ({
      model_rooms: !prevState.model_rooms,
    }));
    this.removeBodyCss();
  }

  tog_facility() {
    this.setState(prevState => ({
      model_facility: !prevState.model_facility,
    }));
    this.removeBodyCss();
  }

  removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  addInput() {
    this.setState(prevState => ({ count: prevState.count + 1 }));
  }

  removeInput() {
    this.setState(prevState => ({ count: prevState.count - 1 }));
  }

  componentDidCatch(error) {
    console.log(error);
    toastr.error("Something Went Wrong", "");
    this.props.history.push('/hotels');
  }

  async componentDidMount() {
    this.loadData();
    this.loadFacilitiesData();
    this.loadRoomsData();
  }

  loadData() {
    const id = this.props.match.params.id;
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    fetch(`${BaseUrl}/api/hotels/hotels/${id}/`, requestOptions)
      .then(res => {
        if (res.status >= 400) {
          this.props.history.push('/hotels');
        } else {
          return res.json();
        }
      })
      .then(data => {
        const breadcrumbItems = [
          { title: "Hotels", link: "/hotels" },
          { title: `Add ${data.hotel.name} Pricing`, link: "#" },
        ];
        this.setState({ hotel: data.hotel, breadcrumbItems });
      });
  }

  loadFacilitiesData = async () => {
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/hotels/rooms_facilities/`, requestOptions)
      .then(res => res.json())
      .then(data => {
        const options = data.map(facility => ({ label: facility.name, value: facility.id }));
        const FacilityGroup = [
          {
            label: "Facilities",
            options: [{ label: "Select All", value: "select-all" }, ...options],
          },
        ];
        this.setState({ FacilityGroup });
      })
      .catch(error => {
        console.log(error, 'error--------------');
      });
  };

  handleselectedFacilityGroup = (selectedOptions) => {
    if (selectedOptions.some(option => option.value === "select-all")) {
      const { FacilityGroup } = this.state;
      if (FacilityGroup.length > 0) {
        this.setState({ selectedFacilities: FacilityGroup[0].options.filter(option => option.value !== "select-all") });
      }
    } else {
      this.setState({ selectedFacilities: selectedOptions });
    }
  };

  async loadRoomsData() {
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/hotels/rooms_types/`, requestOptions)
      .then(res => {
        if (res.status >= 400) {
          return res.json().then(data => {
            console.log(data, 'error--------------');
          });
        } else {
          return res.json();
        }
      })
      .then(data => {
        const options = data.map(room => ({ label: room.name, value: room.id }));
        const selectedRoom = options.length > 0 ? options[0] : "";
        const RoomGroup = [
          {
            label: "Rooms",
            options: options,
          },
        ];
        this.setState({ RoomGroup, selectedRoom });
      })
      .catch(error => {
        console.log(error, 'error--------------');
      });
  }

  handleselectedRoomGroup = (selectedRoom) => {
    this.setState({ selectedRoom });
  };

  handleRoomSubmit(e, values) {
    this.setState({ roomsloding: true });
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      body: JSON.stringify(values),
    };
    fetch(`${BaseUrl}/api/hotels/rooms_types/`, requestOptions)
      .then(res => {
        if (res.status >= 400) {
          return res.json().then(data => {
            toastr.error("Something Went Wrong", "");
            this.setState({ roomsloding: false });
          });
        } else {
          return res.json().then(data => {
            this.loadRoomsData();
            this.setState({ roomsloding: false, model_rooms: false });
          });
        }
      });
  }

  handleFacilitySubmit(e, values) {
    this.setState({ facilityloading: true });
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      body: JSON.stringify(values),
    };
    fetch(`${BaseUrl}/api/hotels/rooms_facilities/`, requestOptions)
      .then(res => {
        if (res.status >= 400) {
          return res.json().then(data => {
            toastr.error("Something Went Wrong", "");
            this.setState({ facilityloading: false });
          });
        } else {
          return res.json().then(data => {
            this.loadFacilitiesData();
            this.setState({ facilityloading: false, model_facility: false });
          });
        }
      });
  }

  handleSubmit(e, values) {
    e.preventDefault();
    const id = this.props.match.params.id;

    if (this.state.selectedRoom.value === null) {
      toastr.error(`Select Room Type`, "");
    } else {
      this.setState({ loading: true });

      const { selectedFacilities } = this.state;
      const facilities = selectedFacilities.map(facility => facility.value);

      const data = {
        hotel: id,
        room_type: this.state.selectedRoom.value,
        extra_bed_price: 0,
        ep_price: values.ep_price,
        cp_price: values.cp_price,
        map_price: values.map_price,
        on_season_ep_price: values.on_season_ep_price,
        on_season_cp_price: values.on_season_cp_price,
        on_season_map_price: values.on_season_map_price,
      };

      if (facilities.length !== 0) {
        data["facilities"] = facilities;
      }

      axios.post(`${BaseUrl}/api/hotels/room_pricing/`, data, {
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      })
      .then(res => {
        const selectedRoom = { label: "Select Room", value: null };
        toastr.success(`Added Successfully`, "");
        this.setState({ loading: false, selectedFacilities: [], selectedRoom });
      })
      .catch(err => {
        toastr.error(`Something Went Wrong`, "");
        this.setState({ loading: false });
        console.log(err, "----------------------error");
      });
    }
  }

  render() {
    const { RoomGroup, selectedFacilities, FacilityGroup, selectedRoom } = this.state;

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs title="" breadcrumbItems={this.state.breadcrumbItems} />
            <AvForm className="needs-validation" id='hotel-pricing' onValidSubmit={this.handleSubmit}>
              <Row>
                <Col xl="6">
                  <Card>
                    <CardBody>
                      <h4 className="card-title">Hotel Pricing Detail</h4>
                      {Array.from(Array(this.state.count)).map((_, index) => (
                        <React.Fragment key={index}>
                          <Row>
                            <Col md="6">
                              <div className="mb-3">
                                <Label className="form-label">Category</Label>
                                <Select
                                  onChange={this.handleselectedRoomGroup}
                                  value={selectedRoom}
                                  options={RoomGroup}
                                  classNamePrefix="select2-selection"
                                />
                              </div>
                            </Col>
                            <Col md="6">
                              <div className="mb-3">
                                <Label className="form-label">Facilities</Label>
                                <Select
                                  value={selectedFacilities}
                                  isMulti={true}
                                  onChange={this.handleselectedFacilityGroup}
                                  options={FacilityGroup.length > 0 ? FacilityGroup[0].options : []}
                                  classNamePrefix="select2-selection"
                                />
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <h5 className="font-size-14 mb-3">Off Season</h5>
                            <Col md="4">
                              <div className="mb-3">
                                <Label className="form-label" htmlFor="price">EP Price</Label>
                                <AvField
                                  name="ep_price"
                                  placeholder="European Plan Price"
                                  type="number"
                                  className="form-control"
                                  errorMessage="Enter Only Number"
                                  validate={{
                                    required: { value: true },
                                    pattern: { value: "^[0-9]+$", errorMessage: "Only Numbers" },
                                  }}
                                  id="price"
                                />
                              </div>
                            </Col>
                            <Col md="4">
                              <div className="mb-3">
                                <Label className="form-label" htmlFor="price">CP Price</Label>
                                <AvField
                                  name="cp_price"
                                  placeholder="Continental Plan Price"
                                  type="number"
                                  className="form-control"
                                  errorMessage="Enter Only Number"
                                  validate={{
                                    required: { value: true },
                                    pattern: { value: "^[0-9]+$", errorMessage: "Only Numbers" },
                                  }}
                                  id="price"
                                />
                              </div>
                            </Col>
                            <Col md="4">
                              <div className="mb-3">
                                <Label className="form-label" htmlFor="price">MAP Price</Label>
                                <AvField
                                  name="map_price"
                                  placeholder="Modified American Plan Price"
                                  type="number"
                                  className="form-control"
                                  errorMessage="Enter Only Number"
                                  validate={{
                                    required: { value: true },
                                    pattern: { value: "^[0-9]+$", errorMessage: "Only Numbers" },
                                  }}
                                  id="price"
                                />
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <h5 className="font-size-14 mb-3">On Season</h5>
                            <Col md="4">
                              <div className="mb-3">
                                <Label className="form-label" htmlFor="on_season_ep_price">EP Price</Label>
                                <AvField
                                  name="on_season_ep_price"
                                  placeholder="European Plan Price"
                                  type="number"
                                  className="form-control"
                                  errorMessage="Enter Only Number"
                                  validate={{
                                    required: { value: true },
                                    pattern: { value: "^[0-9]+$", errorMessage: "Only Numbers" },
                                  }}
                                  id="on_season_ep_price"
                                />
                              </div>
                            </Col>
                            <Col md="4">
                              <div className="mb-3">
                                <Label className="form-label" htmlFor="on_season_cp_price">CP Price</Label>
                                <AvField
                                  name="on_season_cp_price"
                                  placeholder="Continental Plan Price"
                                  type="number"
                                  className="form-control"
                                  errorMessage="Enter Only Number"
                                  validate={{
                                    required: { value: true },
                                    pattern: { value: "^[0-9]+$", errorMessage: "Only Numbers" },
                                  }}
                                  id="on_season_cp_price"
                                />
                              </div>
                            </Col>
                            <Col md="4">
                              <div className="mb-3">
                                <Label className="form-label" htmlFor="on_season_map_price">MAP Price</Label>
                                <AvField
                                  name="on_season_map_price"
                                  placeholder="Modified American Plan Price"
                                  type="number"
                                  className="form-control"
                                  errorMessage="Enter Only Number"
                                  validate={{
                                    required: { value: true },
                                    pattern: { value: "^[0-9]+$", errorMessage: "Only Numbers" },
                                  }}
                                  id="on_season_map_price"
                                />
                              </div>
                            </Col>
                          </Row>
                        </React.Fragment>
                      ))}
                      <FormGroup className="mb-0 mt-1">
                        {this.state.loading ? (
                          <Spinner className="me-2 mt-2" color="primary" />
                        ) : (
                          <div>
                            <Button type="submit" color="primary" className="me-1">
                              Submit
                            </Button>
                            <Button type="button" onClick={() => this.props.history.goBack()} color="secondary">
                              Cancel
                            </Button>
                          </div>
                        )}
                      </FormGroup>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </AvForm>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default AddHotelPricing;
